import { Injectable, Type } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private readonly dialog: Dialog) {}

  public open<T, TD>(component: Type<T>, data?: TD) {
    return this.dialog.open<any>(component, { data }).closed;
  }

  public close() {
    this.dialog.closeAll();
  }
}
